<template>
  <el-container v-title data-title="考勤记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>陌生人刷脸记录</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="起始时间">
                  <el-date-picker
                    v-model="searchForm.searchTimeFrom"
                    type="datetime"
                    placeholder="选择起始时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                  <el-date-picker
                    v-model="searchForm.searchTimeTo"
                    type="datetime"
                    placeholder="选择结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getAttendenceList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="insertTime" label="时间" width="170"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="250"></el-table-column>
          <el-table-column prop="deviceName" label="考勤设备" width="250"></el-table-column>
          <el-table-column prop="temperature" label="体温" width="80"></el-table-column>
          <el-table-column label="考勤图片" width="100">
            <template slot-scope="scope">
              <img :src="scope.row.picUrl.search(/http/i) === 0 ? scope.row.picUrl : GLOBAL.picUrl + scope.row.picUrl" width="64" height="36" @click="openAttendancePicDialog(scope.row.picUrl.search(/http/i) === 0 ? scope.row.picUrl : GLOBAL.picUrl + scope.row.picUrl)"/>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getAttendenceList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <el-dialog
        :visible.sync="attendancePicDialogVisible"
        :width="widthOfAttendancePicDialog"
        :before-close="handleClose"
        :close-on-click-modal="true">
        <img :src="picUrlOnAttendancePicDialog" />
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        deviceType: ''
      },
      schoolList: [],
      attendancePicDialogVisible: false,
      picUrlOnAttendancePicDialog: '',
      widthOfAttendancePicDialog: '200px'
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getAttendenceList()
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getAttendenceList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getAttendenceList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/stranger/meetingRecord/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          searchTimeFrom: _this.searchForm.searchTimeFrom,
          searchTimeTo: _this.searchForm.searchTimeTo,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    openAttendancePicDialog (picUrl) {
      let img = new Image()
      img.src = picUrl
      let _this = this
      img.onload = function () {
        _this.widthOfAttendancePicDialog = this.width + 40 + 'px'
      }
      this.picUrlOnAttendancePicDialog = picUrl
      this.attendancePicDialogVisible = true
    },
    handleClose (done) {
      done()
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StrangerMeetingRecord.vue